import { Level } from "./Logger/CustomLogger/Levels";
import { getTimeStamp } from "../Utils/DateUtils";
import * as FileLogger from "./Logger/CustomLogger/FileLogger";

const LOG_TAG = "LOGSERVICE";
const DEFAULT_LOG_LEVEL = Level.INFO;
let fileAppender = null;

class LogService {
    constructor() {
        this.currentLogLevel = Level.getLevel(localStorage.currentLogLevel, DEFAULT_LOG_LEVEL);

        const config = {
            filename: "LogFile.txt",
            maxLogSize: 10 * 1024 * 1024, // = 10Mb
            // maxLogSize: 1024,
            backups: 5, // keep five backup files
        };
        const layouts = { basicLayout: ((loggingEvent, timezoneOffset) => loggingEvent) };
        FileLogger.configure(config, layouts)
            .then((appender) => {
                console.error(getTimeStamp(), LOG_TAG, "fileappender success");
                fileAppender = appender;
            })
            .catch((error) => {
                console.error(getTimeStamp(), LOG_TAG, "fileappender error:", error);
            });
        console.log(LOG_TAG, "constructor end");
    }

    /**
    * Log a message with level trace
    * @param {String} tag        Tag added to log
    * @param {Object} message    The message to log, with data, can be separated by ,
    */
    trace(tag, ...message) {
        if (Level.TRACE.isGreaterThanOrEqualTo(this.currentLogLevel)) {
            let logMessage = message.map(item => typeof item === "object" ? JSON.stringify(item) : item).join(" ");
            logMessage = this.ellipsizedLog(logMessage);
            const css = "color:" + Level.TRACE.colour;
            console.log("%c%s", css, getTimeStamp() + " TRACE " + tag + " " + logMessage);
            if (fileAppender) {
                fileAppender.write(getTimeStamp() + " TRACE " + tag + " " + logMessage);
            }
        }
    }

    /**
     * Log a message with level debug
    * @param {String} tag        Tag added to log
    * @param {Object} message    The message to log, with data, can be separated by ,
     */
    debug(tag, ...message) {
        if (Level.DEBUG.isGreaterThanOrEqualTo(this.currentLogLevel)) {
            let logMessage = message.map(item => typeof item === "object" ? JSON.stringify(item) : item).join(" ");
            logMessage = this.ellipsizedLog(logMessage);
            const css = "color:" + Level.DEBUG.colour;
            console.log("%c%s", css, getTimeStamp() + " DEBUG " + tag + " " + logMessage);
            if (fileAppender) {
                fileAppender.write(getTimeStamp() + " DEBUG " + tag + " " + logMessage);
            }
        }
    }

    /**
     * Log a message with level info
    * @param {String} tag        Tag added to log
    * @param {Object} message    The message to log, with data, can be separated by ,
     */
    info(tag, ...message) {
        if (Level.INFO.isGreaterThanOrEqualTo(this.currentLogLevel)) {
            let logMessage = message.map(item => typeof item === "object" ? JSON.stringify(item) : item).join(" ");
            logMessage = this.ellipsizedLog(logMessage);
            const css = "color:" + Level.INFO.colour;
            console.log("%c%s", css, getTimeStamp() + " INFO " + tag + " " + logMessage);
            if (fileAppender) {
                fileAppender.write(getTimeStamp() + " INFO " + tag + " " + logMessage);
            }
        }
    }

    /**
     * Log a message with level warning
    * @param {String} tag        Tag added to log
    * @param {Object} message    The message to log, with data, can be separated by ,
     */
    warn(tag, ...message) {
        if (Level.WARN.isGreaterThanOrEqualTo(this.currentLogLevel)) {
            let logMessage = message.map(item => typeof item === "object" ? JSON.stringify(item) : item).join(" ");
            logMessage = this.ellipsizedLog(logMessage);
            const css = "color:" + Level.WARN.colour + ";" + "background: gray";
            console.log("%c%s", css, getTimeStamp() + " WARN " + tag + " " + logMessage);
            if (fileAppender) {
                fileAppender.write(getTimeStamp() + " WARN " + tag + " " + logMessage);
            }
        }
    }

    /**
     * Log a message with level error
    * @param {String} tag        Tag added to log
    * @param {Object} message    The message to log, with data, can be separated by ,
     */
    error(tag, ...message) {
        if (Level.ERROR.isGreaterThanOrEqualTo(this.currentLogLevel)) {
            let logMessage = message.map(item => typeof item === "object" ? JSON.stringify(item) : item).join(" ");
            logMessage = this.ellipsizedLog(logMessage);
            console.error(getTimeStamp(), "ERROR", tag, logMessage);
            if (fileAppender) {
                fileAppender.write(getTimeStamp() + " ERROR " + tag + " " + logMessage);
            }
        }
    }

    setLevel(level) {
        this.currentLogLevel = Level.getLevel(level);
        localStorage.currentLogLevel = this.currentLogLevel.toString();
    }

    getAllLevels() {
        return Level.levels;
    }

    getCurrentLogLevel() {
        return this.currentLogLevel;
    }

    getLogFiles() {
        return fileAppender.zip();
    }

    ellipsizedLog(message) {
        if (message && message.length > 1000)
            return message.substring(0, 1000) + "...";
        return message;
    }
}

export default new LogService();
